import { faFileInvoice, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getServiceAgencyAccountReport } from "../../../Accounting/store/api/DocumentsAPI";
import BihamtaTable from "../../../Components/BihamtaTable";

export default function ModalServiceAgencyAccountReport(props) {

    const { popData, setPopData } = props;
    const { show, serviceID, serviceType, agencyID, saleID } = popData;
    const [list, setList] = useState(null);
    let totalAmount = 0;
    if (list?.Data) {
        totalAmount = list.Data.map(d => Number(d.Credit) - Number(d.Debit)).reduce((a, b) => a + b, 0);
    }
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "شرح ردیف", colName: "RowDescription" },
        { colTitle: "بدهکار", colName: "Debit", colType: "currency", showInMobile:true },
        { colTitle: "بستانکار", colName: "Credit", colType: "currency", showInMobile:true }
    ];
    function close() {
        setPopData({ show: false });
    }
    useEffect(() => {
        if (show && Number(serviceID) > 0 && Number(agencyID) > 0 && serviceType?.length > 1) {
            getServiceAgencyAccountReport(serviceID, serviceType, agencyID, saleID, setList);
        }
    }, [show])
    return (
        <Modal show={show} size="lg" onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faFileInvoice} size="lg" />&nbsp;گردش حساب نماینده برای این سرویس
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <BihamtaTable dataList={list} columns={tableCols} maxHeight={500} />
                <div>
                    <label style={{fontWeight:"bold"}}>مجموع:</label>&nbsp;
                    <span style={{ color: totalAmount < 0 ? "#ff2100" : totalAmount > 0 ? "#138c84" : "unset" }}>
                        <Fragment>
                            {Math.abs(totalAmount).toLocaleString()} {totalAmount < 0 ? "بدهکار" : totalAmount > 0 ? "بستانکار" : ""}
                        </Fragment>
                    </span>
                </div>
            </Modal.Body>
        </Modal>
    )
}